import mock from '../mock'

// Avatar  Images
import avatar8 from '@src/assets/images/portrait/small/avatar-s-8.jpg'
import avatar3 from '@src/assets/images/portrait/small/avatar-s-3.jpg'
import avatar26 from '@src/assets/images/portrait/small/avatar-s-26.jpg'
import avatar25 from '@src/assets/images/portrait/small/avatar-s-25.jpg'

// Icons Imports
import jpgIcon from '@src/assets/images/icons/jpg.png'
import docIcon from '@src/assets/images/icons/doc.png'
import xlsIcon from '@src/assets/images/icons/xls.png'

export const searchArr = [
  {
    groupTitle: 'Pages',
    searchLimit: 4,
    data: [
      {
        id: 1,
        target: 'analyticsDash',
        isBookmarked: true,
        title: 'Analytics Dashboard',
        icon: 'Home',
        link: '/dashboard'
      },
     
      {
        id: 6,
        target: 'calendar',
        isBookmarked: true,
        title: 'Calendar',
        icon: 'Calendar',
        link: '/calendar'
      },
      {
        id: 7,
        target: 'invoiceList',
        isBookmarked: false,
        title: 'Invoice List',
        icon: 'List',
        link: '/invoice/paid'
      },
      
      // {
      //   id: 18,
      //   target: 'login-basic',
      //   isBookmarked: false,
      //   title: 'Login Basic',
      //   icon: 'LogIn',
      //   link: '/pages/login-basic'
      // },
      // {
      //   id: 19,
      //   target: 'login-cover',
      //   isBookmarked: false,
      //   title: 'Login Cover',
      //   icon: 'LogIn',
      //   link: '/pages/login-cover'
      // },
      // {
      //   id: 20,
      //   target: 'register-basic',
      //   isBookmarked: false,
      //   title: 'Register Basic',
      //   icon: 'UserPlus',
      //   link: '/pages/register-basic'
      // },
      // {
      //   id: 21,
      //   target: 'register-cover',
      //   isBookmarked: false,
      //   title: 'Register Cover',
      //   icon: 'UserPlus',
      //   link: '/pages/register-cover'
      // },
      // {
      //   id: 22,
      //   target: 'forgotPassword-basic',
      //   isBookmarked: false,
      //   title: 'Forgot Password Basic',
      //   icon: 'Crosshair',
      //   link: '/pages/forgot-password-basic'
      // },
      // {
      //   id: 23,
      //   target: 'forgotPassword-cover',
      //   isBookmarked: false,
      //   title: 'Forgot Password Cover',
      //   icon: 'Crosshair',
      //   link: '/pages/forgot-password-cover'
      // },
      // {
      //   id: 24,
      //   target: 'resetPassword-basic',
      //   isBookmarked: false,
      //   title: 'Reset Password Basic',
      //   icon: 'TrendingUp',
      //   link: '/pages/reset-password-basic'
      // },
      // {
      //   id: 25,
      //   target: 'resetPassword-cover',
      //   isBookmarked: false,
      //   title: 'Reset Password Cover',
      //   icon: 'TrendingUp',
      //   link: '/pages/reset-password-cover'
      // },
      {
        id: 26,
        target: 'accountSettings',
        isBookmarked: false,
        title: 'Account Settings',
        icon: 'Settings',
        link: '/pages/account-settings'
      },
    
      {
        id: 28,
        target: 'faq',
        isBookmarked: false,
        title: 'FAQ Page',
        icon: 'Zap',
        link: '/pages/faq'
      },
     

      {
        id: 31,
        target: 'blogList',
        isBookmarked: false,
        title: 'Blog List',
        icon: 'List',
        link: '/pages/blog/list'
      },

    ]
  },

]

// GET Search Data
mock.onGet('/api/main-search/data').reply(() => {
  return [200, { searchArr }]
})

// GET Search Data & Bookmarks
mock.onGet('/api/bookmarks/data').reply(() => {
  const bookmarks = searchArr[0].data.filter(item => item.isBookmarked)
  const suggestions = searchArr[0].data
  return [200, { suggestions, bookmarks }]
})

// POST Update isBookmarked
mock.onPost('/api/bookmarks/update').reply(config => {
  const { id } = JSON.parse(config.data)

  const obj = searchArr[0].data.find(item => item.id === id)

  Object.assign(obj, { isBookmarked: !obj.isBookmarked })

  return [200]
})
